import React, { Fragment } from 'react';
import { bool } from 'prop-types';

import WeddingInfoBox from './WeddingInfoBox';
//import ButtonLive from './ButtonLive';
import { styWrapper } from './styles';

function WeddingSection({ isInvitation }) {
  return (
    <Fragment>
      <div id="fh5co-event" css={styWrapper}>
        <div className="overlay" />
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
              <h2 className="main-font main-font__wedding">Ceremonia de boda </h2>
              <span className="sub-title sub-title__wedding">Si Dios quiere, se llevará a cabo:</span>
            </div>
          </div>
          <div className="row">
            <div style={{display:'flex',justifyContent:'center'}} className="col-md-10 col-md-offset-1">
            <WeddingInfoBox
                title="Ceremonia de Boda"
                time="10:30 AM"
                date="Domingo, 08 de Diciembre 2024"
                description="Dirección del lugar, Guatemala"
            />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

WeddingSection.propTypes = {
  isInvitation: bool.isRequired,
};

export default React.memo(WeddingSection);
